/* KAPR productpagina en productvergelijk (fase 1) */
(function () {
  function kaprPdp(root) {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';
    var cfg = JSON.parse(root.querySelector('[data-kapr-pdp-data]').textContent);

    function money(cents) {
      var v = (Math.round(cents) / 100).toFixed(2).replace('.', ',');
      return '€' + v;
    }

    /* Galerij: thumbs, dots en swipe */
    var track = root.querySelector('[data-track]');
    var markers = root.querySelectorAll('[data-thumb]');
    function mark(i) {
      markers.forEach(function (m) { m.setAttribute('aria-current', String(+m.dataset.thumb === i)); });
    }
    markers.forEach(function (m) {
      m.addEventListener('click', function () {
        var i = +m.dataset.thumb;
        track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
        mark(i);
      });
    });
    if (track) {
      var t;
      track.addEventListener('scroll', function () {
        clearTimeout(t);
        t = setTimeout(function () { mark(Math.round(track.scrollLeft / track.clientWidth)); }, 60);
      }, { passive: true });
    }

    /* Aantal en prijs */
    var qtyInput = root.querySelector('[data-qty]');
    var minus = root.querySelector('[data-qty-minus]');
    var tiers = root.querySelectorAll('[data-tier]');
    var staffel = root.querySelectorAll('[data-staffel]');
    function unitFor(q) {
      if (cfg.b2b) {
        var p = cfg.price;
        cfg.breaks.forEach(function (b) { if (q >= b.min) p = b.price; });
        return p;
      }
      if (q >= 3) return cfg.price * (100 - cfg.tier3) / 100;
      if (q === 2) return cfg.price * (100 - cfg.tier2) / 100;
      return cfg.price;
    }
    function render() {
      if (!qtyInput) return;
      var q = Math.max(1, Math.min(999, parseInt(qtyInput.value, 10) || 1));
      qtyInput.value = q;
      if (minus) minus.disabled = q <= 1;
      var unit = unitFor(q), total = unit * q, full = cfg.price * q;
      root.querySelectorAll('[data-total]').forEach(function (el) { el.textContent = money(total); });
      var was = root.querySelector('[data-total-was]');
      if (was) {
        var save = !cfg.b2b && full - total > 1;
        was.hidden = !save;
        if (save) was.textContent = money(full);
      }
      tiers.forEach(function (b) {
        var n = +b.dataset.tier;
        b.setAttribute('aria-pressed', String(n === q || (n === 3 && q > 3)));
      });
      var active = null;
      staffel.forEach(function (b) { if (q >= +b.dataset.staffel) active = b; });
      staffel.forEach(function (b) { b.setAttribute('aria-pressed', String(b === active)); });
      var unitLine = root.querySelector('[data-unit-line]');
      if (unitLine) unitLine.textContent = money(unit) + ' /st excl. btw';
      var sum = root.querySelector('[data-summary]');
      if (sum) sum.textContent = q === 1 ? '1 stuk' : q + ' stuks';
      var left = cfg.freeShip - cfg.cartTotal - total;
      var leftEl = root.querySelector('[data-free-left]'), okEl = root.querySelector('[data-free-ok]');
      if (leftEl && okEl) {
        leftEl.hidden = left <= 0;
        okEl.hidden = left > 0;
        if (left > 0) leftEl.textContent = 'Nog ' + money(left) + ' tot gratis verzending';
      }
    }
    if (qtyInput) {
      qtyInput.addEventListener('input', render);
      qtyInput.addEventListener('change', render);
      minus && minus.addEventListener('click', function () { qtyInput.value = (+qtyInput.value || 1) - 1; render(); });
      var plus = root.querySelector('[data-qty-plus]');
      plus && plus.addEventListener('click', function () { qtyInput.value = (+qtyInput.value || 1) + 1; render(); });
      tiers.forEach(function (b) { b.addEventListener('click', function () { qtyInput.value = b.dataset.tier; render(); }); });
      staffel.forEach(function (b) { b.addEventListener('click', function () { qtyInput.value = b.dataset.staffel; render(); }); });
      render();
    }

    /* Levertijd (Nederlandse tijd) */
    var del = root.querySelector('[data-delivery]');
    if (del) {
      try {
        var parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Amsterdam', weekday: 'short', hour: 'numeric', hour12: false }).formatToParts(new Date());
        var wd = '', hr = 0;
        parts.forEach(function (p) { if (p.type === 'weekday') wd = p.value; if (p.type === 'hour') hr = +p.value; });
        var workday = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'].indexOf(wd) > -1;
        del.textContent = workday && hr < cfg.cutoff ? 'Voor ' + cfg.cutoff + ':00 besteld, vandaag verzonden.' : 'Volgende werkdag verzonden.';
      } catch (e) {}
    }

    /* Plakbalk zodra de koopknop uit beeld is */
    var cta = root.querySelector('[data-cta]'), sticky = root.querySelector('[data-sticky]');
    if (cta && sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        var show = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', String(!show));
        sticky.querySelectorAll('button').forEach(function (b) { b.tabIndex = show ? 0 : -1; });
      }).observe(cta);
    }

    /* Routine */
    var routine = root.querySelector('[data-routine]');
    if (routine) {
      var btnPrice = routine.querySelector('[data-routine-price]');
      var btnLabel = routine.querySelector('[data-routine-label]');
      var addBtn = routine.querySelector('[data-routine-add]');
      function current() {
        return routine.querySelector('[data-set-btn="' + routine.dataset.set + '"][data-for-pre="' + routine.dataset.pre + '"]');
      }
      function sync() {
        routine.querySelectorAll('[data-set-btn]').forEach(function (b) {
          b.setAttribute('aria-pressed', String(b.dataset.setBtn === routine.dataset.set));
        });
        routine.querySelectorAll('[data-pre-btn]').forEach(function (b) {
          b.setAttribute('aria-pressed', String(b.dataset.preBtn === routine.dataset.pre));
        });
        var c = current();
        var ok = c && c.dataset.variants && !c.disabled;
        btnPrice.textContent = ok ? money(+c.dataset.price) : '';
        addBtn.disabled = !ok;
        addBtn.style.opacity = ok ? '' : '.4';
      }
      routine.querySelectorAll('[data-set-btn]').forEach(function (b) {
        b.addEventListener('click', function () { routine.dataset.set = b.dataset.setBtn; sync(); });
      });
      routine.querySelectorAll('[data-pre-btn]').forEach(function (b) {
        b.addEventListener('click', function () { routine.dataset.pre = b.dataset.preBtn; sync(); });
      });
      addBtn.addEventListener('click', function () {
        var c = current();
        if (!c || !c.dataset.variants) return;
        addBtn.setAttribute('aria-busy', 'true');
        var routes = (window.theme && theme.routes) || {};
        fetch((routes.cart_add_url || '/cart/add') + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: c.dataset.variants.split(',').map(function (id) { return { id: +id, quantity: 1, properties: { _routine: c.dataset.label || 'Routine' } }; }) })
        }).then(function (r) { return r.json(); }).then(function (res) {
          if (res.status) throw new Error(res.description || 'Fout');
          return fetch((routes.cart_url || '/cart') + '.js').then(function (r) { return r.json(); });
        }).then(function (cart) {
          btnLabel.textContent = '✓ Routine toegevoegd';
          setTimeout(function () { btnLabel.textContent = 'Routine toevoegen'; }, 1800);
          if (window.theme && theme.pubsub) theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'kapr-routine', cart: cart });
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));
          var drawer = document.querySelector('cart-drawer');
          if (drawer && drawer.show) drawer.show(addBtn);
        }).catch(function (e) {
          btnLabel.textContent = e.message;
          setTimeout(function () { btnLabel.textContent = 'Routine toevoegen'; }, 2500);
        }).finally(function () { addBtn.removeAttribute('aria-busy'); });
      });
      sync();
    }
  }
  function kaprKv(root) {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';
    var sc = root.querySelector('[data-scroll]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-card]'));
    var prev = root.querySelector('[data-prev]'), next = root.querySelector('[data-next]');
    var fade = root.querySelector('[data-fade]'), bar = root.querySelector('[data-progress]');
    function measure() {
      var max = Math.max(0, sc.scrollWidth - sc.clientWidth);
      if (prev) prev.disabled = sc.scrollLeft <= 4;
      if (next) next.disabled = sc.scrollLeft >= max - 4;
      if (fade) fade.style.opacity = sc.scrollLeft < max - 4 ? 1 : 0;
      if (bar && sc.scrollWidth) {
        bar.style.width = Math.min(100, sc.clientWidth / sc.scrollWidth * 100) + '%';
        bar.style.left = (sc.scrollLeft / sc.scrollWidth * 100) + '%';
      }
    }
    function step(dir) {
      var c = cards[0];
      var w = c ? c.offsetWidth + 16 : 300;
      sc.scrollBy({ left: dir * w * Math.max(1, Math.floor(sc.clientWidth / w)), behavior: 'smooth' });
    }
    function scrollToCard(card, instant) {
      var pad = parseFloat(getComputedStyle(sc).paddingLeft) || 0;
      var left = sc.scrollLeft + card.getBoundingClientRect().left - sc.getBoundingClientRect().left - pad;
      sc.scrollTo({ left: left, behavior: instant ? 'auto' : 'smooth' });
    }
    prev && prev.addEventListener('click', function () { step(-1); });
    next && next.addEventListener('click', function () { step(1); });
    sc.addEventListener('scroll', measure, { passive: true });
    window.addEventListener('resize', measure);
    root.querySelectorAll('[data-filter]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var f = btn.dataset.filter;
        root.querySelectorAll('[data-filter]').forEach(function (b) { b.setAttribute('aria-pressed', String(b === btn)); });
        root.classList.toggle('is-filtered', f !== 'all');
        var first = null;
        cards.forEach(function (c) {
          var match = f === 'all' || c.dataset.look === f || c.dataset.hold === f;
          c.classList.toggle('is-dim', !match);
          if (match && !first) first = c;
        });
        if (first) scrollToCard(first);
      });
    });
    var active = root.querySelector('.kv-card.is-active');
    if (active) {
      var go = function () {
        var prevBehavior = sc.style.scrollBehavior;
        sc.style.scrollBehavior = 'auto';
        var cardsPerView = Math.max(1, Math.floor(sc.clientWidth / (active.offsetWidth + 16)));
        var idx = cards.indexOf(active);
        if (idx >= cardsPerView - 1) scrollToCard(cards[Math.max(0, idx - cardsPerView + 2)] || active, true);
        sc.style.scrollBehavior = prevBehavior;
        measure();
      };
      if (document.readyState === 'complete') setTimeout(go, 150); else window.addEventListener('load', function () { setTimeout(go, 150); });
    }
    measure();
  }

  function kaprInit() {
    document.querySelectorAll('[data-kapr-pdp]').forEach(kaprPdp);
    document.querySelectorAll('[data-kapr-kv]').forEach(kaprKv);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', kaprInit); else kaprInit();
  document.addEventListener('shopify:section:load', kaprInit);
})();
